module.exports = __webpack_public_path__ + "img/loginBackground.261fc631.png";